import React from 'react'
import type { ClickAwayListenerProps as MuiClickAwayListenerProps } from '@material-ui/core/ClickAwayListener'
import MuiClickAwayListener from '@material-ui/core/ClickAwayListener'

export type ClickAwayListenerProps = MuiClickAwayListenerProps

function ClickAwayListener(props: ClickAwayListenerProps) {
  return <MuiClickAwayListener {...props} />
}

export default ClickAwayListener
